import BillingsOrderCargoTaxiCreateRequest, {
  BillingsOrderCargoTaxiCreateRequestBillingNode,
  BillingsOrderCargoTaxiCreateRequestContribution,
  BillingsOrderCargoTaxiCreateRequestContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiCreateRequestContributionDiscountBeingLate,
  BillingsOrderCargoTaxiCreateRequestContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiCreateRequestContributionDiscountOptimization,
  BillingsOrderCargoTaxiCreateRequestContributionDiscountOther,
  BillingsOrderCargoTaxiCreateRequestContributionType,
} from "../../../../../api/raily/billings/order/cargo-taxi/create/billings-order-cargo-taxi-create.request";
import BillingsOrderCargoTaxiCreateParams, {
  BillingsOrderCargoTaxiCreateParamsBillingNode,
  BillingsOrderCargoTaxiCreateParamsContribution,
  BillingsOrderCargoTaxiCreateParamsContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiCreateParamsContributionDiscountBeingLate,
  BillingsOrderCargoTaxiCreateParamsContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiCreateParamsContributionDiscountOptimization,
  BillingsOrderCargoTaxiCreateParamsContributionDiscountOther,
  BillingsOrderCargoTaxiCreateParamsContributionType,
} from "./billings-order-cargo-taxi-create-params";

const createContributionContractCorrectionPercentage = (
  contribution: BillingsOrderCargoTaxiCreateParamsContributionContractCorrectionPercentage,
): BillingsOrderCargoTaxiCreateRequestContributionContractCorrectionPercentage => {
  return {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.CONTRACT_CORRECTION_PERCENTAGE,
    comment: contribution.comment,
    percentage: contribution.percentage,
    amount: contribution.amount,
  };
};

const createContributionDiscountBeingLate = (
  contribution: BillingsOrderCargoTaxiCreateParamsContributionDiscountBeingLate,
): BillingsOrderCargoTaxiCreateRequestContributionDiscountBeingLate => {
  return {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_BEING_LATE,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountIncompatibleCar = (
  contribution: BillingsOrderCargoTaxiCreateParamsContributionDiscountIncompatibleCar,
): BillingsOrderCargoTaxiCreateRequestContributionDiscountIncompatibleCar => {
  return {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_INCOMPATIBLE_CAR,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountOptimization = (
  contribution: BillingsOrderCargoTaxiCreateParamsContributionDiscountOptimization,
): BillingsOrderCargoTaxiCreateRequestContributionDiscountOptimization => {
  return {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_OPTIMIZATION,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContributionDiscountOther = (
  contribution: BillingsOrderCargoTaxiCreateParamsContributionDiscountOther,
): BillingsOrderCargoTaxiCreateRequestContributionDiscountOther => {
  return {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_OTHER,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createContribution = (
  contribution: BillingsOrderCargoTaxiCreateParamsContribution,
): BillingsOrderCargoTaxiCreateRequestContribution => {
  switch (contribution.type) {
    case BillingsOrderCargoTaxiCreateParamsContributionType.CONTRACT_CORRECTION_PERCENTAGE:
      return createContributionContractCorrectionPercentage(contribution);
    case BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_BEING_LATE:
      return createContributionDiscountBeingLate(contribution);
    case BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_INCOMPATIBLE_CAR:
      return createContributionDiscountIncompatibleCar(contribution);
    case BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_OPTIMIZATION:
      return createContributionDiscountOptimization(contribution);
    case BillingsOrderCargoTaxiCreateParamsContributionType.DISCOUNT_OTHER:
      return createContributionDiscountOther(contribution);
  }
};

const createContributions = (
  contributions: BillingsOrderCargoTaxiCreateParamsContribution[],
): BillingsOrderCargoTaxiCreateRequestContribution[] => {
  return contributions.map(createContribution);
};

const createNode = (
  node: BillingsOrderCargoTaxiCreateParamsBillingNode,
): BillingsOrderCargoTaxiCreateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    plannedDistance: node.plannedDistance,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
  };
};

const createNodes = (
  nodes: BillingsOrderCargoTaxiCreateParamsBillingNode[],
): BillingsOrderCargoTaxiCreateRequestBillingNode[] => {
  return nodes.map(createNode);
};

const create = (
  params: BillingsOrderCargoTaxiCreateParams,
): BillingsOrderCargoTaxiCreateRequest => {
  return {
    billingContributions: createContributions(params.billingContributions),
    billingNodes: createNodes(params.billingNodes),
    orderUuid: params.orderUuid,
  };
};

const billingsOrderCargoTaxiCreateParamsFactory = {
  create,
};

export default billingsOrderCargoTaxiCreateParamsFactory;
